import { newE2EPage } from '@stencil/core/testing';

describe('salla-cart-summary', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<salla-cart-summary></salla-cart-summary>');

    const element = await page.find('salla-cart-summary');
    expect(element).toHaveClass('hydrated');
  });
});
